<template>
  <div class="city-container">
    <div id="banner">

      <img src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107288795a0be4afce345.png" width="100%"
        alt="">
    </div>
    <div id="content">

      <div id="about" class="block " style="padding-top:3.6rem; margin-top:-10px;">
        <h3 class="title" style="margin-top:-1rem">
          <span>关于大会</span>
        </h3>
        <div class="info">
          <p>曾记否，2016年底，格隆汇在全国八大城市举办“决战港股2016”—海外投资系列峰会，成功引爆内地资金对港股市场的关注。 随后，港股在内地南下资金的推动下，走势冠绝全球。年初至今累计涨幅30.28%，成功创出十年新高，领涨全球市场。
          </p>
          <p>今年，格隆汇“决战港股”将再次起航，本年度“决战港股2017”将继续由格隆汇主办，由腾讯Fintech全程独家冠名，由香港交易所全程支持，携手金融界、创投界及实业界大咖，云集一众优质海外上市公司，于2017年11月8日至2017年12月20日期间，在深圳、上海、北京及广州四大核心城市举办“决战港股2017——海外投资系列峰会”。并获得超过30家金融机构、超过30家国内一线媒体、超过200家港股优质上市公司的全程支持、覆盖和参与。格隆汇将为国内投资者奉上年底港股投资的饕餮盛宴，敬请期待。</p>
        </div>
      </div>
      <div id="guest" class="block">
        <h3 class="title">
          <span>演讲嘉宾</span>
        </h3>

        <div class="btl"></div>
        <div id="cards" class="flex-container">

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/1510730054523廖艺2.jpg" width="130%"
                alt="">
            </div>
            <div class="uname">廖艺</div>
            <div class="profile">
              <p>香港交易所市场发展科中国客户关系及市场推广部副总裁

              </p>
            </div>
          </div>
          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-6px" src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107292615a0be62d98d09.jpg"
                width="120%" alt="">
            </div>
            <div class="uname">刘央</div>
            <div class="profile">
              <p>西京投资集团主席兼投资总监
              </p>
            </div>
          </div>
        </div>




        <div id="cards" class="flex-container">




          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107291415a0be5b4f07b8.jpg"
                width="130%" alt="">
            </div>
            <div class="uname">李迅雷 </div>
            <div class="profile">
              <p>中泰证券首席经济学家兼研究所所长</p>
            </div>
          </div>

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:0px" src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107293635a0be693b7424.jpg"
                width="110%" alt="">
            </div>
            <div class="uname">王磊</div>
            <div class="profile">
              <p>华泰金融控股（香港）有限公司CEO
              </p>
            </div>
          </div>
        </div>





        <h3 class="title" style="margin-bottom:20px;">
          <span>往期嘉宾</span>
        </h3>
        <div class="btl"></div>
        <div id="cards" class="flex-container">
          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/李开复.jpg" width="130%" alt="">
            </div>
            <div class="uname">李开复</div>
            <div class="profile">
              <p>创新工场董事长兼首席执行官
              </p>
            </div>
          </div>

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/徐小平.jpg" width="130%" alt="">
            </div>
            <div class="uname"> 徐小平</div>
            <div class="profile">
              <p> 真格基金创始人、新东方联合创始人
              </p>
            </div>
          </div>

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/蔡文胜.jpg" width="130%" alt="">
            </div>
            <div class="uname">蔡文胜</div>
            <div class="profile">
              <p>美图创始人兼董事长 著名天使投资人
              </p>
            </div>
          </div>

        </div>



        <div id="cards" class="flex-container">
          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-1px" src="/static/高善文.jpg" width="110%" alt="">
            </div>
            <div class="uname"> 高善文</div>
            <div class="profile">
              <p> 安信证券首席经济学家</p>
            </div>
          </div>



          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/但斌.jpg" width="130%" alt="">
            </div>
            <div class="uname">但斌</div>
            <div class="profile">
              <p>深圳东方港湾投资管理股份有限公司董事长</p>
            </div>
          </div>

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/李婷.jpg" width="130%" alt="">
            </div>
            <div class="uname">李婷</div>
            <div class="profile">
              <p>云锋金融执行董事，CEO
              </p>
            </div>
          </div>






        </div>




        <div id="cards" class="flex-container">


          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/赵晓光.jpg" width="130%" alt="">
            </div>
            <div class="uname">赵晓光</div>
            <div class="profile">
              <p>天风证券研究所所长</p>
            </div>
          </div>
          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/张忆东.jpg" width="130%" alt="">
            </div>
            <div class="uname">张忆东</div>
            <div class="profile">
              <p>兴业证券研究所副所长，全球首席策略分析师
              </p>
            </div>
          </div>

          <div class="flex-item">
            <div class="face">
              <img style="margin-left:-12px" src="/static/张化桥.jpg" width="130%" alt="">
            </div>
            <div class="uname"> 张化桥</div>
            <div class="profile">
              <p> 中国支付通控股有限公司董事会主席</p>
            </div>
          </div>



        </div>

        <div class="more-partner more-bottom" @click='showMore'>

          <span v-if="!status">查看更多往期嘉宾</span>
          <span v-else>隐藏更多往期嘉宾</span>
        </div>
        <div class="more--parterner-container" v-if='status'>
          <div id="cards" class="flex-container">
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/赵文利.jpg" width="130%" alt="">
              </div>
              <div class="uname">赵文利</div>
              <div class="profile">
                <p>招商证券（香港）首席策略师兼执行董事
                </p>
              </div>
            </div>
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/韩贤旺.png" width="130%" alt="">
              </div>
              <div class="uname">韩贤旺</div>
              <div class="profile">
                <p>汇添富基金首席经济学家
                </p>
              </div>
            </div>

            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/周晓殷.jpg" width="130%" alt="">
              </div>
              <div class="uname">周晓殷</div>
              <div class="profile">
                <p>港交所市场发展科中国客户关系及市场推广部高级副总裁
                </p>
              </div>
            </div>




          </div>

          <div id="cards" class="flex-container">
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/廖艺.jpeg" width="130%" alt="">
              </div>
              <div class="uname">廖艺</div>
              <div class="profile">
                <p>香港交易所市场发展科中国客户关系及市场推广部副总裁
                </p>
              </div>
            </div>
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/李颖文.jpg" width="130%" alt="">
              </div>
              <div class="uname"> 李颖文</div>
              <div class="profile">
                <p> 香港交易所市场发展科经理
                </p>
              </div>
            </div>
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/杨伊.jpg" width="130%" alt="">
              </div>
              <div class="uname"> 杨伊</div>
              <div class="profile">
                <p> 香港交易及结算所有限公司中国客户关系及市场推广部资深经理
                </p>
              </div>
            </div>







          </div>

          <div id="cards" class="flex-container">
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/谢勤发.jpg" width="130%" alt="">
              </div>
              <div class="uname">谢勤发</div>
              <div class="profile">
                <p>云锋金融投资银行部董事总经理
                </p>
              </div>
            </div>
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/王庆仁.jpg" width="130%" alt="">
              </div>
              <div class="uname">王庆仁</div>
              <div class="profile">
                <p>东海证券（国际）CEO
                </p>
              </div>
            </div>
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/高欣.png" width="130%" alt="">
              </div>
              <div class="uname"> 高欣</div>
              <div class="profile">
                <p> 汇添富港币债券基金经理
                </p>
              </div>
            </div>







          </div>
          <div id="cards" class="flex-container">
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/黄晓黎.png" width="130%" alt="">
              </div>
              <div class="uname">黄晓黎</div>
              <div class="profile">
                <p>曦域资本创始人
                </p>
              </div>
            </div>

            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/周道传.png" width="130%" alt="">
              </div>
              <div class="uname">周道传</div>
              <div class="profile">
                <p>云锋金融研究及策略总监，董事总经理
                </p>
              </div>
            </div>

            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/左龙右鲤.jpg" width="130%" alt="">
              </div>
              <div class="uname">左龙右鲤</div>
              <div class="profile">
                <p>先健互联网金融医疗联合创始人
                </p>
              </div>
            </div>

          </div>
          <div id="cards" class="flex-container">
            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/罗旭峰.jpg" width="130%" alt="">
              </div>
              <div class="uname">罗旭峰</div>
              <div class="profile">
                <p>南华期货股份有限公司总经理
                </p>
              </div>
            </div>

            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/秦波.jpg" width="130%" alt="">
              </div>
              <div class="uname"> 秦波</div>
              <div class="profile">
                <p> 光大证券海外研究部总经理
                </p>
              </div>
            </div>

            <div class="flex-item">
              <div class="face">
                <img style="margin-left:-12px" src="/static/董承非.jpg" width="130%" alt="">
              </div>
              <div class="uname">董承非</div>
              <div class="profile">
                <p>兴业全球基金管理部投资总监
                </p>
              </div>
            </div>




          </div>

        </div>

      </div>

      <!-- <div id="agenda" class="block">


        <div>
          <img src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107290065a0be52e40ffb.png" alt="" width="100%"> </div>

        <div>
          <img src="http://glhsns.img-cn-hangzhou.aliyuncs.com/201711/p20171104111542812.png" width="100%" alt="">
        </div>



      </div> -->

      <div class="block">
        <h3 class="title">
          <span>参会方式</span>
        </h3>

        <p style="font-size:0.8rem;line-height:1.6rem;color:#555;padding-left:8px;">
          <span style="color:#bc3f31">●</span>　因名额有限，申请需经官方筛选
          <br>
          <span style="color:#bc3f31">●</span>　申请通过，格隆汇将通过电话或短信的方式
          <br>　　发送入场凭证，请确保联系方式填写无误
          <br>
          <span style="color:#bc3f31">●</span>　信息填写完整更容易获得入场机会
          <br>
        </p>
        <div class="apply_btn">
          <img @click='goGuide' src="/static/btn.png" width="100%" alt="">
        </div>
        <p class="ps">更多详情请关注格隆汇官网和公众号
          <br> 官网：www.gelonghui.com
          <br> 公众号：港股那点事
        </p>


      </div>

      <div id="map" class="block">
        <h3 class="title">
          <span>参会地点</span>
        </h3>
        <p class="ps"> 时间：2017.11.21
          <br> 地址：上海威斯汀大饭店（上海市河南中路88号）
          <br> 交通：10号线豫园站1口出/17路、66路、306路河南中路延安东路站
        </p>
        <!-- <div class="block">
          <img src="/static/map.png" width="100%">
        </div> -->
      </div>
      <div class="partner">
        <div class="apply_btn">
          <img src="/static/partner.jpg" width="100%" alt="">
        </div>

        <div>
          <img src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171115/151073005452315107290065a0be52e40ffb.png" width="100%"
            alt="">
        </div>



      </div>



    </div>
  </div>
</template>

<script>
  export default {
    name: 'cityinfo',
    mounted() {
      window.document.title = '决战港股--2017站';
      window.location = '/2017beijing.html'
    },
    methods: {
      goGuide() {
        this.$router.push("/midGuide")
      },
      showMore() {
        this.status = !this.status
      }
    },
    data() {
      return {
        status: false
      }
    }
  }

</script>

<style scoped>
  .more-partner {
    text-align: center;
    font-size: 14px;
  }

  .more-bottom {
    /* margin-bottom: 3rem; */
  }

  .more-partner span {
    text-decoration: underline;
  }

  .more--parterner-container {
    padding-top: 3rem;
  }

  .partner {
    text-align: center;
    padding-bottom: 40px;
  }

  .partner .info-column {
    margin: 10px 0;
  }

  .partner .info-column {
    line-height: 1.5em;
  }

  .partner .info-column h3 {
    color: rgb(180, 53, 38);
    font-weight: normal;
  }



  .city-container {
    font: 12px/1.0 "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
    background: url(https://asset.mikecrm.com/getimg/origin/images/formTemplate/img-bmsq-0-0.jpg)!important;
    height: 100%;
  }

  #banner {
    max-width: 640px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 0;
  }

  #content {
    max-width: 640px;
    width: 100%;
    margin: 0 auto;
    background: #FFF;
  }

  h3.title {

    text-align: center;
    height: 1.12em;
    border-bottom: 1px solid #bc3f31;
    margin: 10px;
    margin-bottom: 2rem;
  }

  h3.title span {

    color: #fff;
    font-size: .9rem;
    line-height: 2rem;
    text-align: center;
    padding: .5rem;
    font-weight: 90%;
    background: #bc3f31;
    border-radius: .5rem;
  }

  div.info {
    padding-top: 1rem;
    color: #666;
    font-size: 0.9rem;
    line-height: 1.5rem;
    margin: 10px;
  }

  .block {
    padding: 3%;
  }



  #agenda .block h4 {
    height: 43px;
    line-height: 43px;
    padding-left: 50px;
    margin-top: 30px;
    color: #666;
    font-size: 18px;
    font-weight: 300;
    font-family: Arial, Helvetica, sans-serif;
    background: url(/static/dot.png) left center no-repeat;
  }

  #agenda .block h5 {
    height: 56px;
    line-height: 56px;
    padding-left: 50px;
    margin-top: 0px;
    color: #666;
    font-size: 14px;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
    background: url(/static/dot1.png) left center no-repeat;
  }

  #agenda .block h5 span.t {
    display: inline-block;
    font-weight: 100;
    font-size: 0.6rem;
    text-align: center;
    padding: 0 6px;
    color: #FFF;
    line-height: 22px;
    margin-left: .3rem;
    border-radius: .3rem;
  }

  #agenda .block .list table {
    width: 100%;
    margin-left: 4px;
    background: url(/static/line1.png) left top repeat-y;
  }

  span.ta {
    background: #F9B72C
  }

  span.tb {
    background: #CBDE5A
  }

  span.tc {
    background: #70C2EF
  }

  span.td {
    background: #BF85E6
  }

  span.te {
    background: #FE5358
  }

  span.tf {
    background: #00C68F
  }

  #agenda .block .list table td.zuo,
  #agenda .block .list table th {
    text-align: left;
    width: 45%;
    line-height: 29px;
    font-size: 14px;
    color: #909090;
    padding-left: 43px;
  }

  #agenda .block .list table td {
    font-size: 14px;
    color: #666;
  }

  .btl {
    padding: 10px;
    text-align: center;
    width: 50%;
    margin: 2rem auto;
    margin-bottom: 3rem;
  }

  .flex-container {
    display: flex;
    width: 100%;
    margin-bottom: 3rem;
  }

  .flex-item {
    background-color: #C22519;
    flex-grow: 3;
    margin: 2%;
    width: 40%;
    border-radius: .3rem;
    padding-bottom: 1rem;
  }

  .flex-item .face {
    width: 4rem;
    height: 4rem;
    border-radius: 100px;
    border: 3px solid #E06B61;
    overflow: hidden;
    margin: 0 auto;
    margin-top: -2.5rem;
  }

  .flex-item .uname {
    padding-top: .6rem;
    text-align: center;
    color: #FFF;
    font-weight: bold;
    font-size: .9rem;
  }

  .flex-item .profile {

    clear: both;
    font-size: 0.7rem;
    text-align: center;
    padding: 0.6rem;
    color: #F8F8F8;
    font-weight: 100;
    text-align: center;
    line-height: .9rem;
    padding-top: 1.5rem;
  }

  p.ps {
    background: #EEDAD8;
    color: #333;
    font-size: 0.8rem;
    line-height: 1.5rem;
    padding: 1rem;
    margin: 1rem .6rem;
  }

  .apply_btn {
    width: 40%;
    margin: 2rem auto
  }

</style>



// WEBPACK FOOTER //
// src/components/frontend/cityInfo.vue